import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AxiosError } from 'axios'
import { FinancialRecordStatus } from '@/types'

type UpdatePaymentRecordStatusBody = {
  status: FinancialRecordStatus
  reject_reason?: string
}

type UpdatePaymentRecordStatusPayload = UpdatePaymentRecordStatusBody & {
  deal_key: string
  payment_record_key: string
}

export async function updatePaymentRecordStatus({
  deal_key,
  payment_record_key,
  ...body
}: UpdatePaymentRecordStatusPayload) {
  const response = await httpClient('accounting-dealer').put<void>(
    `/v3/deal/${deal_key}/payment-record/${payment_record_key}`,
    body,
  )

  return response.data
}

export function useUpdatePaymentRecordStatus(
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    UpdatePaymentRecordStatusPayload,
    unknown
  >,
) {
  return useMutation({
    mutationFn: updatePaymentRecordStatus,
    ...options,
  })
}
